<template>
  <b-row v-if="me.contact.website">
    <b-col md="4" class="mt-2">
      <b-img-lazy fluid :src="me.contact.small_image" :alt="me.contact.name + ' image'"></b-img-lazy>
    </b-col>
    <b-col md="8" class="mt-1">
      <a
        aria-label="DanCodes.online"
        target="_blank"
        rel="noopener noreferrer"
        :href="me.contact.website"
      >
        <h1>{{ me.contact.name }}</h1>
      </a>
      <p>{{ me.contact.about_me }}</p>
    </b-col>
  </b-row>
</template>
<script>
export default {
  data() {
    return { me: { contact: {} } };
  },
  mounted() {
    let vm = this;
    fetch("https://api.dancodes.online/api/v2/fetch")
      .then(res => res.json())
      .then(data => {
        vm.me = data;
      });
  }
};
</script>
